import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { apiError } from "@/context/AuthContext";
import BlacklistForm from "@/components/BlacklistForm";
import BulkImport from "@/components/BulkImport";
import { toast } from "sonner";
import { FilePlus2, PencilLine } from "lucide-react";

export default function AdminBlacklistForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initial, setInitial] = useState(id ? null : {});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) api.get(`/blacklist/${id}`).then((r) => setInitial(r.data)).catch(() => toast.error("Không tải được dữ liệu"));
  }, [id]);

  const submit = async (payload) => {
    setLoading(true);
    try {
      if (id) {
        await api.put(`/admin/reports/${id}`, payload);
        toast.success("Đã cập nhật danh sách đen");
      } else {
        await api.post("/admin/reports", payload);
        toast.success("Đã thêm vào danh sách đen");
      }
      navigate("/danh-sach-den");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (id && !initial) return <p className="text-zinc-600">Đang tải...</p>;

  return (
    <div className="max-w-3xl">
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white flex items-center gap-3">
        {id ? <PencilLine className="w-9 h-9 text-primary" /> : <FilePlus2 className="w-9 h-9 text-primary" />}
        {id ? "Chỉnh sửa thông tin" : "Thêm vào danh sách đen"}
      </h1>
      <p className="text-zinc-500 mt-2 mb-6">
        {id ? "Cập nhật thông tin khách hàng trong danh sách đen." : "Tài khoản gốc thêm trực tiếp một khách vào danh sách đen (được duyệt ngay)."}
      </p>
      {!id && (
        <div className="mb-8">
          <BulkImport />
          <div className="my-8 flex items-center gap-3 text-zinc-600">
            <div className="h-px bg-zinc-800 flex-1" />
            <span className="text-xs uppercase tracking-widest">hoặc thêm thủ công 1 người</span>
            <div className="h-px bg-zinc-800 flex-1" />
          </div>
        </div>
      )}
      <BlacklistForm initial={initial} onSubmit={submit} submitting={loading} submitLabel={id ? "Lưu thay đổi" : "Thêm vào danh sách đen"} />
    </div>
  );
}
